import { Button } from "@devhop/ui";
import { HelpCircle, PlusIcon } from "lucide-react";

type TemplateToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
  onStartTour?: () => void;
};

export function TemplateToolbar({
  canManage,
  onCreate,
  onStartTour,
}: TemplateToolbarProps) {
  return (
    <div className="mb-4 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <div className="flex items-center space-x-2">
            <h2 className="font-bold text-2xl tracking-tight">
              ລາຍການຮ່າງເອກະສານ
            </h2>
            <Button
              variant="ghost"
              size="icon"
              className="size-7 rounded-full"
              onClick={onStartTour}
            >
              <HelpCircle className="size-5" />
            </Button>
          </div>
          <p className="text-muted-foreground">
            ຈັດການຮ່າງເອກະສານ (Template) ສໍາລັບໃຊ້ງານໃນອົງກອນ ເຊັ່ນ ຮ່າງເອກະສານ PO, PR, ບີນ, ອິນວອຍສ໌ ແລະອື່ນໆ
          </p>
        </div>
        {canManage && (
          <div className="flex items-center space-x-2">
            <div data-tourid="template-toolbar">
              <Button onClick={onCreate}>
                <PlusIcon className="h-4 w-4" />
                ເພີ່ມຮ່າງເອກະສານໃໝ່
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
